import 'globals/outside.js';
import Backbone from "backbone/outside/outside.js";
import Page from 'lib/page.js';

Page.init(Backbone);



// WEBPACK FOOTER //
// ./app/javascript/packs/outside.js